import shallowDeepEqual from 'src/utils/shallowDeepEqual';

export const returnFreshState = (originalState: any, newState: any, opts?: Parameters<typeof shallowDeepEqual>[2]) => {
  return shallowDeepEqual(originalState, newState, opts)
    ? originalState
    : newState
}

export default returnFreshState
